import React, { useState, useContext } from 'react';
import {
	Select,
	Chip,
	Box,
	MenuItem,
	Checkbox,
	ListItemText,
	Typography,
	Link,
	Tooltip
} from '@material-ui/core';
import {
	FORM_SEL_CONDITION_LBL,
	FILTER_CONDITION_LABELS,
	OTIF_TMPT_LIST,
	PROTIP_TEXT_104_WEEKS,
	PROTIP_LEARN_MORE,
	PROTIP_LEARN_MORE_BASIC,
	LEARN_MORE,
	STR_TMPT_LIST,
	DC_TMPT_LIST,
	MUMD_ORDER_LIST,
	OLD_PROTIP_TEXT_104_WEEKS,
	HELP_ARTICLE,
	FOR_MORE_INFORMATION,
	OMNI_TMPT_LIST,
	ECOM_INVENTORY,
	ECOM_SALES_LIST,
	REGISTER_SALES_LIST
} from 'constants/constant';
import { colors } from 'theme/color-palette';
import {
	MultiTimeSelCal,
	wmtLastFiftyTwoWeeks,
	wmtLastOneHundredAndFourWeeks
} from './FilterCondition';
import DateRangeIcon from '@material-ui/icons/DateRange';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import styles from './FilterForm.style';
import { useSelector } from 'react-redux';
import { deepClone } from 'helper/helper';
import { getBaseUrl, isBasicPersona } from 'helper/utils';
import { UserPortalContext } from 'context/appcontext';

const selectAll = 'Select All';

const MultiSelectInputCondition = (props) => {
	const { condition, customClass, cbHandleSelInpConChg } = props;
	const [time, setTime] = useState(Array.isArray(condition) ? condition : condition.split(','));
	const [anchorEl, setAnchorEl] = useState(null);
	const selectedTemplate = useSelector((state) => state.templateReducer.selectedTemplate);
	const classes = styles();

	const portalUserContext = useContext(UserPortalContext);
	const isBasic = isBasicPersona(portalUserContext.customerType);

	const isNotCustomAndNot104Weeks = (value) => {
		return value !== wmtLastOneHundredAndFourWeeks && value !== 'Custom';
	};

	function handleChange(event) {
		event.stopPropagation();
		let {
			target: { value }
		} = event;
		value = typeof value === 'string' ? value.split(',') : value;
		value = value.filter((val) => val !== '');
		if (value.includes(wmtLastOneHundredAndFourWeeks)) {
			if (
				time.length > 0
					? time.includes(wmtLastOneHundredAndFourWeeks)
					: condition.includes(wmtLastOneHundredAndFourWeeks)
			) {
				/**
				 * If any other filter is being selected while Last 104 weeks was previously selected then remove Last 104 weeks option and add recently selected option
				 */
				value = value.filter((val) => val !== wmtLastOneHundredAndFourWeeks);
				/**
				 * If the previously select value is last 104 weeks and the current value selected is Custom, then we close out the dropdown
				 */
				if (value.includes('Custom')) {
					value = 'Custom';
					cbHandleSelInpConChg(value.split(','));
				}
				/**
				 * If select all is being selected while Last 104 weeks is already selected, then remove custom and last 104 weeks and select everything else
				 */
				if (value.includes(selectAll)) {
					value = MultiTimeSelCal.filter((val) => isNotCustomAndNot104Weeks(val.value)).map(
						(val) => val.value
					);
				}
			} else {
				value = wmtLastOneHundredAndFourWeeks;
				/**
				 * If Last 104 weeks is being selected then the dropdown needs to be a single-select dropdown
				 * Hence, setting isMultifilter as false and calling handleDateChange method explicitly
				 */
				cbHandleSelInpConChg(value.split(','));
			}
		} else if (value.includes('Custom')) {
			/**
			 * Handle custom filter
			 */
			if (time.length > 0 ? time.includes('Custom') : condition.includes('Custom')) {
				/**
				 * If any other filter is being selected while Custom was previously selected then remove Custom option and add recently selected option
				 */
				value = value.filter((val) => val !== 'Custom');
				/**
				 * If select all is being selected while custom is already selected
				 */
				if (value.includes(selectAll)) {
					value = MultiTimeSelCal.filter((val) => isNotCustomAndNot104Weeks(val.value)).map(
						(val) => val.value
					);
				}
			} else {
				value = 'Custom';
				/**
				 * If custom is being selected then we need to behave this select as single select
				 * Hence, setting isMultifilter as false and calling handleDateChange method explicitly
				 */
				cbHandleSelInpConChg(value.split(','));
			}
		} else if (value.includes(selectAll)) {
			/**
			 * Handle select all filter
			 */
			if (time.length > 0 ? time.includes(selectAll) : condition.includes(selectAll)) {
				/**
				 * If select all filter is already selected then deselect all options
				 */
				value = MultiTimeSelCal.filter(
					(val) =>
						!value.includes(val.value) &&
						val.value !== 'Custom' &&
						val.value !== wmtLastOneHundredAndFourWeeks
				).map((val) => val.value);
			} else {
				/**
				 * If select all is not already selected then select all options but custom
				 */
				value = MultiTimeSelCal.filter(
					(val) => val.value !== 'Custom' && val.value !== wmtLastOneHundredAndFourWeeks
				).map((val) => val.value);
			}
		} else {
			/**
			 * If select all is already selected and select all is re-selected then de-select every options
			 */
			if (time.length > 0 ? time.includes(selectAll) : condition.includes(selectAll)) {
				value = '';
			} else if (value.length > 0) {
				value = value.filter((con) => con !== 'Custom');
			} else {
				value = '';
			}
		}
		setTime(typeof value === 'string' ? value.split(',') : value);
	}

	const getProToolTipText52Weeks = () => {
		return (
			<Box className={classes.tooltipPanel}>
				<Typography className={classes.tooltipText}>
					{OLD_PROTIP_TEXT_104_WEEKS}{' '}
					<Link
						href={`${getBaseUrl()}${isBasic ? PROTIP_LEARN_MORE_BASIC : PROTIP_LEARN_MORE}`}
						target="_blank"
						className={classes.underlineText}
						style={{ textDecoration: 'underline', color: colors.PURPLE }}>
						{HELP_ARTICLE}
					</Link>
					{FOR_MORE_INFORMATION}
				</Typography>
			</Box>
		);
	};

	const getProToolTipText104Weeks = () => {
		// TODO: Change the href link when it is available.
		return (
			<Box className={classes.tooltipPanel}>
				<Typography className={classes.tooltipText}>
					<Link
						href={`${getBaseUrl()}${isBasic ? PROTIP_LEARN_MORE_BASIC : PROTIP_LEARN_MORE}`}
						target="_blank"
						className={classes.underlineText}
						style={{ textDecoration: 'underline', color: colors.PURPLE }}>
						{LEARN_MORE}
					</Link>
					{` ${PROTIP_TEXT_104_WEEKS}`}
				</Typography>
			</Box>
		);
	};

	function getMTSOptions() {
		let list = deepClone(MultiTimeSelCal);

		// Remove 104 weeks option if it isn't SSI, MUMD, Omni sales, Ecom inventory, Ecom Sales, Register Sales or DC
		let is104WeeksPresent = true;
		const isSSI = STR_TMPT_LIST.includes(Number(selectedTemplate));
		const isDC = DC_TMPT_LIST.includes(Number(selectedTemplate));
		const isMUMD = MUMD_ORDER_LIST.includes(Number(selectedTemplate));
		const isOmniSales = OMNI_TMPT_LIST.includes(Number(selectedTemplate));
		const isEcomInventory = ECOM_INVENTORY.includes(Number(selectedTemplate));
		const isEcomSales = ECOM_SALES_LIST.includes(Number(selectedTemplate));
		const isRegiSales = REGISTER_SALES_LIST.includes(Number(selectedTemplate));

		if (
			!isSSI &&
			!isDC &&
			!isMUMD &&
			!isOmniSales &&
			!isEcomInventory &&
			!isEcomSales &&
			!isRegiSales
		) {
			list = list.filter((el) => el.value !== wmtLastOneHundredAndFourWeeks);
			is104WeeksPresent = false;
		}

		if (OTIF_TMPT_LIST.includes(Number(selectedTemplate))) {
			list = list.filter((el) => el.label !== FILTER_CONDITION_LABELS.WMT_LAST_WEEK);
		}

		const oneHundredAndFourStyles = { paddingLeft: '48px' };

		return list.map((el, index) => {
			const is104WeeksOption = el.value === wmtLastOneHundredAndFourWeeks;

			return (
				<MenuItem key={index} value={el.value} name={el.value} className={classes.fontStyle}>
					{el.value !== 'Custom' && !is104WeeksOption && (
						<Checkbox
							size="small"
							color="primary"
							style={{ marginRight: '10px' }}
							checked={
								time.length > 0 ? time.indexOf(el.value) > -1 : condition.indexOf(el.value) > -1
							}
						/>
					)}
					{el.value === 'Custom' && (
						<DateRangeIcon style={{ marginLeft: '10px', marginRight: '10px' }} />
					)}

					<Box
						display="flex"
						alignItems="center"
						style={is104WeeksOption ? oneHundredAndFourStyles : {}}>
						<ListItemText primary={el.label} />
						{el.value === wmtLastFiftyTwoWeeks && !is104WeeksPresent && (
							<Box>
								<Tooltip
									title={getProToolTipText52Weeks()}
									arrow
									style={{ maxWidth: '100px' }}
									leaveDelay={3000}
									placement="top"
									clickable>
									<InfoOutlinedIcon
										style={{ color: '#6D6E71', marginTop: '4px', marginLeft: '4px' }}
										fontSize="small"
									/>
								</Tooltip>
							</Box>
						)}
						{el.value === wmtLastOneHundredAndFourWeeks && (
							<Box>
								<Tooltip
									title={getProToolTipText104Weeks()}
									arrow
									style={{ maxWidth: '100px' }}
									leaveDelay={3000}
									placement="top"
									clickable>
									<InfoOutlinedIcon
										style={{ color: '#6D6E71', marginTop: '4px', marginLeft: '4px' }}
										fontSize="small"
									/>
								</Tooltip>
							</Box>
						)}
					</Box>
				</MenuItem>
			);
		});
	}

	return (
		<Select
			MenuProps={{
				anchorEl: anchorEl,
				getContentAnchorEl: null
			}}
			value={time}
			multiple={true}
			onOpen={(event) => setAnchorEl(event.currentTarget)}
			onChange={(event) => {
				handleChange(event);
			}}
			onClose={() => {
				setAnchorEl(null);
				cbHandleSelInpConChg(time.length > 0 ? time.join(',') : condition);
			}}
			label={FORM_SEL_CONDITION_LBL}
			className={customClass}
			renderValue={(selected) =>
				selected.indexOf('Custom') < 0 ? (
					<Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 8 }}>
						{selected
							.filter((value) => value !== '' && value !== 'Select All')
							.map((value, idx) => (
								<Chip
									key={idx}
									id={`multi-time-${idx}`}
									variant="outlined"
									label={value}
									tabIndex="0"
								/>
							))}
					</Box>
				) : (
					selected
				)
			}
			id="select-input">
			{getMTSOptions()}
		</Select>
	);
};

export default MultiSelectInputCondition;
